export default Object.freeze({
    Yes: 'Yes',
    No: 'No',
});
